import { SUPPORTED_CITIES, type SupportedCity } from '../domain/cities';

type CitySelectorProps = {
  selectedCity: SupportedCity | null;
  onSelect: (city: SupportedCity) => void;
};

export function CitySelector({ selectedCity, onSelect }: CitySelectorProps) {
  return (
    <div className="city-grid">
      {SUPPORTED_CITIES.map((city) => (
        <button
          key={city.id}
          className={`city-card${selectedCity?.id === city.id ? ' selected' : ''}`}
          onClick={() => onSelect(city)}
        >
          {city.name}
        </button>
      ))}
    </div>
  );
}
